import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import apiHelper from "../../helpers/api";
import "../../static/css/login.css";

class Login extends Component {
  /**
   * Authorize the user using the entered credentials.
   *
   * @param {Object} event The desired event to be fired.
   */
  formSubmitHandler = event => {
    const email = document.getElementById("email");
    const password = document.getElementById("password");
    email.classList.remove("error");
    password.classList.remove("error");
    document.getElementById("sub-btn").innerHTML = "Logging in...";
    apiHelper
      .hasAccess(email.value, password.value)
      .then(response => {
        // console.log(response);
        if (response.status === "success") {
          this.props.history.push("/date");
          this.props.setAuthorizedStatus(response.data.token);
        } else {
          document.getElementById("sub-btn").innerHTML = "Login";
          this.props.showAlert("danger", response.error);
        }
      })
      .catch(error => {
        // console.log(error);
        document.getElementById("sub-btn").innerHTML = "Login";
        this.props.showAlert(
          "danger",
          "There seems to be an error! Kindly check your internet connection or contact system admins"
        );
      });
    event.preventDefault();
  };

  /**
   * Toggle the password field type and their icons between text and password.
   */
  toggleIconHandler = () => {
    let password = document.getElementById("password");
    if (password.getAttribute("type") === "password")
      password.setAttribute("type", "text");
    else password.setAttribute("type", "password");
    let type = document.getElementById("toggleType");
    type.classList.toggle("icon-ic-show");
    type.classList.toggle("icon-ic-hide");
  };

  render() {
    return (
      <div className="login-wrpr lgt-thm">
        {this.props.alertBox}
        <div className="main-wrpr text-center">
          <div className="container">
            <div className="logo-wrpr center-block"></div>
            <div className="frm-wrpr center-block">
              <form
                className="clearfix"
                onSubmit={e => this.formSubmitHandler(e)}
              >
                <div className="elem-wrpr">
                  <i className="icon icon-ic-uid" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="input-box"
                    placeholder="Username"
                    required
                  />
                </div>
                <div className="elem-wrpr">
                  <i className="icon icon-ic-pass" />
                  <input
                    type="password"
                    id="password"
                    name="password"
                    className="input-box"
                    placeholder="Password"
                    required
                  />
                  <i
                    id="toggleType"
                    className="icon icon-ic-hide"
                    onClick={this.toggleIconHandler}
                  />
                </div>
                <button type="submit" id="sub-btn" className="btn semi-bold">
                  Login
                </button>
              </form>
            </div>
            <span className="cpy-btm">
              Copyright &copy; {new Date().getFullYear()} Media.net All Rights
              Reserved
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
